export enum UserRole {
  asset_manager = 'tmm_manager',
  technician = 'tmm_technician',
  trane_admin = 'tmm_admin',
}
